import { useContext } from "react";
import {
  CompanyProvisionWizardContext,
  type CompanyProvisionWizardContextValue,
} from "../components/BulkCreateCompanyWizardContext";

/**
 * Read the bulk company-creation wizard's shared state from within any
 * screen rendered under `BulkCreateCompanyWizardProvider`.
 *
 * @throws if called outside the provider.
 */
export function useCompanyProvisionWizard(): CompanyProvisionWizardContextValue {
  const ctx = useContext(CompanyProvisionWizardContext);
  if (!ctx) {
    throw new Error(
      "useCompanyProvisionWizard must be used within a BulkCreateCompanyWizardProvider"
    );
  }
  return ctx;
}
